import React, { useEffect } from 'react';
import { leyDisciplinaFinanciera2021 } from '../../json/leyDisciplinaFinanciera2021';
import '../LeyDisciplinaFinanciera/leyDisciplinaFinanciera.css';

  const LeyDisciplinaFinanciera2021 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Ley de Disciplina Financiera 2021</h2>
            <hr className='hr-gob'/>
          </div>

            <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="nombreDocumentoEncabezadoLDF" style={{ width: "600px" }}>Documento</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>1er. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>2do. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>3er. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>4to. Trim</div></th>
                      </tr>
            </table>
         </div>

          <div className="contenedor-tablaLDF">
            <table className="table table-striped table-bordered tabla-elementosLDF">
                    <tbody>
                       {
                        leyDisciplinaFinanciera2021.map((item, index)=>(
                          <tr key={ index }>
                              <th><div className="detalle_iLDF"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row">
                                <div className="detalle_documentoLDF2022"> { item.nombre } </div>
                              </th>
                              <td>
                                <div className="div-elementosLDF2022">
                                    <a href={ item.link1erTrimPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td>
                              <td>
                                <div className="div-elementosLDF2022">
                                    <a href={ item.link2doTrimPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td>
                              <td>
                                <div className="div-elementosLDF2022">
                                    <a href={ item.link3erTrimPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td>
                              <td>
                                <div className="div-elementosLDF2022">
                                    <a href={ item.link4toTrimPDF } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td> 
                          </tr>
                        ))
                       }
                  </tbody>
              </table>
          </div>         
       </div>
    </div>

    )
}

export default LeyDisciplinaFinanciera2021